import * as React from 'react';
import classNames from 'classnames';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Button, Text, Section} from 'components/UIKit';
import * as images from './images';
import styles from './SocialProof.scss';
import * as locales from './locales';

export type Testimonial = {
  key: string;
  name: string;
  store: string;
  quote: string;
};

export interface SocialProofProps {
  ctaPath: string;
}

export function SocialProofComponent({ctaPath, i18n}: SocialProofProps & WithI18nProps) {
  return (
    <Section
      heading={i18n.translate('heading')}
      subhead={i18n.translate('subhead')}
      headingProps={{align: 'center'}}
      subheadProps={{align: 'center'}}
      headerSpacing="small"
    >
      <div className={styles.Items}>
        {locales.en.testimonials.map((testimonial, index) => (
          <div className={styles.Item} key={testimonial.key}>
            <img src={images[testimonial.key]} alt={testimonial.name} className={styles.Image} />
            <Text text={testimonial.name} className={styles.Name} resetMargin />
            <Text text={i18n.translate(`testimonials.${index}.store`)} type="small" secondary />
            <Text text={i18n.translate(`testimonials.${index}.quote`)} />
          </div>
        ))}
        <div className={classNames(styles.Item, styles.CtaBlock)}>
          <div>
            <Text text={i18n.translate('ctaHeading')} type="h4" component="p" />
            <Button url={ctaPath} label={i18n.translate('cta')} />
          </div>
        </div>
      </div>
    </Section>
  );
}

export const SocialProof = withI18n({
  id: 'SocialProof',
  fallback: locales.en,
})(SocialProofComponent);
